import type { UpdateUserBrandDTO } from "@src/domain/dto/users";
import type { UserDetailsBrand } from "@src/domain/entities/auth/user/UserDetails";
import type { IUserRepository } from "@src/domain/repositories/user";

export class UpdateUserBrandUseCase {
  private readonly userRepository: IUserRepository;

  constructor(userRepository: IUserRepository) {
    this.userRepository = userRepository;
  }

  async execute(params: UpdateUserBrandDTO): Promise<UserDetailsBrand> {
    try {
      const updatedBrand = await this.userRepository.updateUserBrand(params);
      if (!updatedBrand) {
        throw new Error("No brand assignment returned");
      }
      return updatedBrand;
    } catch (error) {
      console.error("Failed to assign brand to user:", error);
      if (error instanceof Error && error.message.trim()) {
        throw error;
      }
      throw new Error("Failed to assign brand to user");
    }
  }
}
